import { TextField } from '@mui/material';

interface CustomerDomainFieldProps {
  value: string;
  error?: string;
  setValue: (value: string) => void;
}

function CustomerDomainField({
  value,
  error,
  setValue,
}: CustomerDomainFieldProps): React.JSX.Element {
  return (
    <TextField
      fullWidth
      required
      label='Customer Domain'
      value={value}
      error={Boolean(error)}
      helperText={error}
      onChange={(e) => setValue(e.target.value)}
    />
  );
}

export default CustomerDomainField;

